import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Bootstrap must be imported BEFORE App so the app's own global styles
// (e.g. `a { text-decoration: none }` in App.css) override Bootstrap Reboot's
// defaults at equal specificity, rather than being clobbered by them.
import 'bootstrap/dist/css/bootstrap.min.css';
// Tailwind utilities for the home page (scoped to .rd-home, see tailwind.config.js).
import './styles/tailwind.css';
import App from './App';
// Site-wide design-system layer (tokens, Bootstrap bridge, header/footer). Loaded last.
import './styles/rd-site.css';
import './styles/rd-icons.css';
//import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { UserFormDataProvider } from './context/FormDataContext';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Disable the browser's automatic scroll restoration so client-side route
// changes always start at the top instead of restoring the previous page's
// scroll offset (which caused the pre-onboarding page to open mid/bottom and
// then visibly scroll up). Pages reset scroll themselves on mount.
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const appTree = (
  <UserFormDataProvider>
    <App />
  </UserFormDataProvider>
);

root.render(
  <BrowserRouter>
    <React.StrictMode>
      {process.env.REACT_APP_ENABLE_LOGIN === "true" ? (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          {appTree}
        </GoogleOAuthProvider>
      ) : appTree}
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
